<div
  id="offconon-layout"
  class="min-h-screen p-2 h-screen overflow-hidden relative"
  data-testid="layout">
  @if (isLoggedIn) {
    <offconon-left-sidebar
      data-testid="layout__sidebar"
      [sideNavData]="sideNavData"
      [sideBarVisible]="sideBarVisible()"
      (sideBarVisibleChange)="setSideBar($event)" />
  }
  <div
    class="min-h-screen flex flex-col relative flex-auto max-w-screen-xl mx-auto"
    id="offconon-layout-main"
    data-testid="layout__container">
    <nav
      #cardContainer
      class="flex justify-between gap-2 pb-2"
      id="offconon-layout-header"
      data-testid="layout__header">
      <div class="flex flex-row gap-2" data-testid="layout__header-left" id="layout__header-left">
        <div class="flex items-center justify-center">
          <a
            data-testid="layout__menu-button"
            class="cursor-pointer ml-2 mr-3 dark:text-white flex"
            (click)="setSideBar(true)">
            <i class="pi pi-bars text-4xl"></i>
          </a>
        </div>

        <a
          class="flex no-hover"
          data-testid="layout__logo-link"
          [attr.aria-label]="'OffConOn' | translate"
          [routerLink]="['/' + currentLanguage]">
          <div class="flex items-center justify-between cursor-pointer" data-testid="layout__logo">
            <div class="flex items-center">
              <img
                src="/assets/images/offconon.svg"
                class="mr-2 h-8 md:h-10"
                alt="{{ 'OffConOn' | translate }}" />
              <div class="hidden md:block dark:text-white">
                <span class="text-xl capitalize font-semibold hidden lg:block"> OFFCONON </span>
              </div>
            </div>
          </div>
        </a>
        @if (isLoggedIn) {
          <div
            class="flex-grow-1 flex items-center justify-center"
            data-testid="layout__header-left-content">
            <ng-content select="[left]" />
          </div>
        }
      </div>
      <div
        class="grow flex items-center md:justify-center gap-2"
        id="layout__header-center"
        data-testid="layout__header-center">
        @if (user) {
          @if (platform === 'erp') {
            <div>
              <ng-content select="[erp_app_list]" />
            </div>
          } @else {
            <div>
              <p-button
                icon="pi pi-th-large"
                class="rounded-full header-button"
                severity="secondary"
                tooltipPosition="bottom"
                ariaLabel="{{ 'Applications' | translate }}"
                pTooltip="{{ 'Applications' | translate }}"
                (click)="apps.toggle($event)" />
              <p-popover #apps appendTo="'body'" styleClass="z-50" (click)="apps.toggle($event)">
                <div class="max-h-[calc(95dvh-var(--layout-header-height))] overflow-y-auto">
                  <div class="flex flex-wrap gap-5 max-w-[44rem] p-3">
                    <div>
                      <div class="font-bold text-xs uppercase mb-3">
                        {{ 'Marketplaces' | translate }}
                      </div>
                      <offconon-app-list-render
                        [filter]="'marketplaces'"
                        [settings]="{
                          description: false,
                          arrow: false,
                          comingsoon: false,
                          size: 'small'
                        }" />
                    </div>
                    <div>
                      <div class="font-bold text-xs uppercase mb-3">
                        {{ 'Communities' | translate }}
                      </div>
                      <offconon-app-list-render
                        [filter]="'communities'"
                        [settings]="{
                          description: false,
                          arrow: false,
                          comingsoon: false,
                          size: 'small'
                        }" />
                    </div>
                    <div>
                      <div class="font-bold text-xs uppercase mb-3">
                        {{ 'Productivity tools' | translate }}
                      </div>
                      <offconon-app-list-render
                        [filter]="'productivity'"
                        [settings]="{
                          description: false,
                          arrow: false,
                          comingsoon: false,
                          size: 'small'
                        }" />
                    </div>
                  </div>
                </div>
              </p-popover>
            </div>
          }
        }
        <ng-content select="[center]" />
      </div>
      <div class="flex items-center justify-end" data-testid="layout__header-right">
        @defer {
          @if (user) {
            <offconon-feedback-common />
          }
        }
        <ng-content select="[rightSide]" />
        @defer {
          @if (user) {
            <div
              class="h-10 p-2 md:p-3 lg:px-3 lg:py-2 items-center hover:bg-blue-500 hover:text-white font-bold cursor-pointer transition-duration-150 transition-colors dark:text-white p-button-rounded"
              pTooltip="{{ 'Open chat' | translate }}"
              [attr.aria-label]="'Open chat' | translate"
              (click)="toggleRightColumn()">
              <mat-icon> chat</mat-icon>
            </div>
          }
        }
      </div>
    </nav>
    <div class="flex flex-row justify-center w-full gap-2" data-testid="layout__content">
      <div
        id="left-section"
        data-testid="layout__left-column"
        class="flex overflow-auto gap-2 flex-col rounded-lg"
        [ngClass]="[
          'phonePortrait:fixed phonePortrait:w-screen phonePortrait:h-screen phonePortrait:z-40 phonePortrait:top-0 phonePortrait:left-0  phonePortrait:!rounded-none ',
          'phoneLandscape:fixed phoneLandscape:w-80 phoneLandscape:h-full phoneLandscape:z-40 phoneLandscape:top-0 phoneLandscape:left-0 phoneLandscape:!rounded-none',
          'tabletPortrait:flex  tabletPortrait:w-20 tabletPortrait:h-[calc(100dvh-var(--layout-header-height))]',
          'tabletLandscape:flex tabletLandscape:w-20 tabletLandscape:h-[calc(100dvh-var(--layout-header-height))]',
          'laptop:w-20 laptop:h-[calc(100dvh-var(--layout-header-height))]',
          'desktop:w-20 desktop:h-[calc(100dvh-var(--layout-header-height))]',
          '4k:w-80 4k:h-[calc(100dvh-var(--layout-header-height))]',
          (layoutService.columnVisibility.leftBottom() ||
            layoutService.columnVisibility.leftTop()) &&
          leftColumnVisible()
            ? 'phonePortrait:rounded-none phoneLandscape:rounded-none tabletLandscape:fixed tabletPortrait:fixed tabletLandscape:z-40 tabletPortrait:z-40 tabletLandscape:top-0 tabletPortrait:top-0 tabletLandscape:left-0 tabletPortrait:left-0 tabletPortrait:w-80 tabletLandscape:w-80 tabletPortrait:h-screen tabletLandscape:h-screen flex desktop:w-80 laptop:w-80 '
            : 'phonePortrait:hidden phoneLandscape:hidden flex w-20 left-menu-small',
          layoutService.columnVisibility.leftTop() || layoutService.columnVisibility.leftBottom()
            ? ''
            : 'hidden'
        ]">
        <div
          [ngClass]="[
            (layoutService.columnVisibility.leftBottom() ||
              layoutService.columnVisibility.leftTop()) &&
            !leftColumnVisible()
              ? 'flex justify-center'
              : 'hidden'
          ]">
          <p-button
            icon="pi pi-arrows-h"
            class="p-button-text p-button-plain p-button-rounded cursor-pointer"
            [ariaLabel]="'Toggle left column' | translate"
            (click)="toggleLeftColumn()" />
        </div>
        <div
          id="layout__left-top"
          data-testid="layout__left-top"
          [ngClass]="
            layoutService.columnVisibility.leftTop() || layoutService.columnVisibility.leftBottom()
              ? ''
              : '!hidden'
          ">
          <ng-container #leftTopContainer />
        </div>
        <div class="grow">
          <div
            id="layout__left-bottom"
            data-testid="layout__left-bottom"
            [ngClass]="
              layoutService.columnVisibility.leftBottom() ? 'h-full  overflow-auto' : '!hidden'
            ">
            <ng-container #leftBottomContainer />
          </div>
        </div>
        <div class="menu-overlay p-overlay-mask hidden" (click)="toggleLeftColumn()"></div>
      </div>

      <div
        #content
        class="w-80 flex-grow max-w-screen-xl h-[calc(100dvh-var(--layout-header-height))] overflow-auto"
        id="layout__main-section"
        data-testid="layout__main"
        (scroll)="onScroll($event)">
        <div
          #contentContainer
          class="flex-grow flex flex-col"
          id="layout__main-content"
          data-testid="layout__main-content">
          <div id="layout__main-header-container">
            <ng-container #contentHeaderContainer />
          </div>
          <div id="layout__main-content-container">
            <router-outlet />
          </div>
        </div>
      </div>
      @if (user) {
        <div
          id="right-section"
          data-testid="layout__right-column"
          [ngClass]="[
            !rightColumnVisible()
              ? 'hidden'
              : '!h-100dvh md:!h-[calc(100dvh-var(--layout-header-height))]',
            'fixed md:relative',
            'z-50 md:z-auto',
            'top-0 left-0 md:top-auto md:left-auto',
            'w-full layout-section',
            layoutService.columnVisibility.rightBottom() ||
            layoutService.columnVisibility.rightTop()
              ? 'md:w-80 '
              : 'hidden',
            layoutService.columnVisibility.rightBottom() &&
            layoutService.columnVisibility.rightTop()
              ? 'gap-3'
              : '',
            'h-screen   md:h-auto'
          ]">
          <div
            id="layout__right-bottom"
            data-testid="layout__right-bottom"
            [ngClass]="[
              layoutService.columnVisibility.rightBottom() ||
              layoutService.columnVisibility.rightTop()
                ? 'max-h-full'
                : '!hidden',
              'w-full'
            ]">
            <div class="flex md:hidden justify-end">
              <p-button
                icon="pi pi-times"
                [link]="true"
                [ariaLabel]="'Close right column' | translate"
                (click)="toggleRightColumn()" />
            </div>
            <ng-container #rightBottomContainer />
          </div>
        </div>
      }
    </div>
  </div>
</div>
@if (layoutService.columnVisibility.leftBottom() || layoutService.columnVisibility.leftTop()) {
  <div
    class="hidden phonePortrait:block phoneLandscape:block fixed bottom-2 left-3 z-10 box-bg rounded-full">
    <p-button
      icon="pi pi-arrows-h"
      styleClass="!rounded-full !opacity-100 cursor-pointer"
      [ariaLabel]="'Toggle left column' | translate"
      (click)="toggleLeftColumn()" />
  </div>
}
@defer (on idle) {
  <p-toast position="top-right" />

  <offconon-fcm />

  <offconon-subscription-upgrade-dialog />
}
